exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-gp-privacy-tsx": () => import("./../../../src/pages/gp-privacy.tsx" /* webpackChunkName: "component---src-pages-gp-privacy-tsx" */),
  "component---src-pages-gp-terms-tsx": () => import("./../../../src/pages/gp-terms.tsx" /* webpackChunkName: "component---src-pages-gp-terms-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */)
}

